const { h, render, Component } = require('preact');

class DropDown extends Component {
  constructor(props) {
    super(props);
    this.changeDropdownState = this.changeDropdownState.bind(this)
    this.isInputGiven = this.isInputGiven.bind(this)
  }

  getInputHtmlElement() {
    var elementId = "dropdown-forms" + this.props.attrs.counter
    return document.getElementById(elementId)
  }

  changeDropdownState() {
    this.props.updateState(this.props.attrs.type, this.props.attrs.counter, this.populateInput(), this.validateInput())
  }

  isInputGiven() {
   return this.readInput().length > 0
  }

  getDropdownOptions(options) {
    var dropDownOptionKey, dropDownOptionPayload, dropdownOptions, ref;

    dropdownOptions = [];

    for (dropDownOptionKey in options) {
      dropDownOptionPayload = options[dropDownOptionKey];
      if (dropDownOptionPayload.key != null) {
        if (((ref = dropDownOptionPayload.value) != null ? ref.length : void 0) > 0) {
          dropdownOptions.push({
            id: dropDownOptionPayload.value,
            text: dropDownOptionPayload.key
          });
        } else {
          dropdownOptions.push({
            id: dropDownOptionPayload.key,
            text: dropDownOptionPayload.key
          });
        }
      } else {
        dropdownOptions.push({
          id: dropDownOptionPayload,
          text: dropDownOptionPayload
        });
      }
    }

    return dropdownOptions;
  }

  isInputValid() {
    return true
  }

  readInput() {
    var dropdownElement = this.getInputHtmlElement()
    var opt = dropdownElement.options[dropdownElement.selectedIndex]
    return opt.text
  }

  populateInput() {
    var data = {}
    if (this.isInputGiven()) {
      var inputData = this.readInput()
      data.description = `\n\n ${this.props.attrs.label} : ${inputData}`
    }
  }

  validateInput() {
    if (this.props.attrs.required == "true") {
      return this.isInputGiven() && this.isInputValid()
    }
    return true
  }

  componentDidMount() {
    var dropdown = this.getInputHtmlElement()
    dropdown.addEventListener("change", this.changeDropdownState)
    dropdown.addEventListener("change", this.changeDropdownState)
  }

  render() {
    var attrs = this.props.attrs
    var dropdownOptions = this.getDropdownOptions(attrs.additional_attributes.options)

    return (
      <div>
        <label><strong>{this.props.attrs.label}</strong>
          {attrs.required == "true" ? (<span class="mandatory-field"> * </span>) : null}
          </label>
        <div>
          <select class="dropdown_input" data-bhw={'dropdown_input' + this.props.attrs.counter}
                  area-label={this.props.attrs.label} id = {"dropdown-forms" + attrs.counter}>
            <option value="" selected>{I18n.translate('js.modules.support.categoryselect')}</option>
            {
              dropdownOptions.map((item) =>
                <option value={item.id}>{item.text}</option>)
            }
          </select>
        </div>
      </div>
    )
  }
}
module.exports = DropDown
